<section class="admin-page-grid">
  <div class="admin-panel-stack">
    <section class="admin-card">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">Catalogue</div>
          <h2>Manager les plans</h2>
        </div>
        <button class="secondary-button" type="button" (click)="startCreate()">
          Nouveau plan
        </button>
      </div>

      <div class="admin-stats-grid admin-stats-grid--three">
        <article class="admin-stat-card">
          <span>Plans</span>
          <strong>{{ plans().length }}</strong>
          <small>{{ activePlanCount() }} actifs</small>
        </article>
        <article class="admin-stat-card">
          <span>Self-serve</span>
          <strong>{{ selfServePlanCount() }}</strong>
          <small>Plans avec cle Stripe configuree</small>
        </article>
        <article class="admin-stat-card">
          <span>Features</span>
          <strong>{{ featureCatalog().length }}</strong>
          <small>Catalogue partage entre les plans</small>
        </article>
      </div>
    </section>

    <section class="admin-card">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">Catalogue live</div>
          <h2>Plans disponibles</h2>
        </div>
      </div>

      <div class="admin-feedback" *ngIf="feedback()" [class.success]="feedbackType() === 'success'" [class.error]="feedbackType() === 'error'">
        {{ feedback() }}
      </div>

      <div class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Plan</th>
              <th>Prix</th>
              <th>Stripe</th>
              <th>Features</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of plans(); trackBy: trackPlan">
              <td>
                <div class="admin-table-primary">{{ plan.name }}</div>
                <div class="admin-table-secondary">{{ plan.key }}</div>
              </td>
              <td>
                <div class="admin-table-primary">{{ plan.displayPriceLabel || '—' }}</div>
                <div class="admin-table-secondary" *ngIf="plan.monthlyPriceEuros !== null">{{ plan.monthlyPriceEuros }}€ numerique</div>
              </td>
              <td>
                <div class="admin-table-primary">{{ hasStripePrice(plan) ? 'Configuree' : 'Sales only' }}</div>
                <div class="admin-table-secondary">{{ plan.stripePriceId || 'Aucune cle' }}</div>
              </td>
              <td>
                <div class="admin-pill-list">
                  <span class="admin-badge" *ngFor="let featureKey of plan.features">{{ featureLabel(featureKey) }}</span>
                </div>
              </td>
              <td>
                <div class="admin-table-primary">{{ plan.active ? 'Actif' : 'Desactive' }}</div>
                <div class="admin-table-secondary">Ordre {{ plan.sortOrder || 0 }}</div>
              </td>
              <td>
                <div class="admin-actions-cell">
                  <button class="secondary-button" type="button" (click)="editPlan(plan)">Editer</button>
                  <button class="secondary-button" type="button" (click)="togglePlanActive(plan)" [disabled]="actionPlanKey() === plan.key">
                    {{ plan.active ? 'Desactiver' : 'Reactiver' }}
                  </button>
                  <button class="secondary-button" type="button" (click)="deletePlan(plan)" [disabled]="actionPlanKey() === plan.key">
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="!plans().length">
              <td colspan="6" class="admin-empty-row">
                Aucun plan a afficher.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <aside class="admin-card admin-form-card">
    <div class="admin-card-head">
      <div>
        <div class="admin-eyebrow">{{ selectedPlanKey() ? 'Edition' : 'Creation' }}</div>
        <h2>{{ selectedPlanKey() ? 'Editer un plan' : 'Ajouter un plan' }}</h2>
      </div>
    </div>

    <form class="admin-form" [formGroup]="form" (ngSubmit)="submit()">
      <label class="admin-field">
        <span>Cle plan</span>
        <input type="text" formControlName="key" placeholder="forge-expert" [readonly]="!!selectedPlanKey()" />
      </label>

      <label class="admin-field">
        <span>Nom</span>
        <input type="text" formControlName="name" placeholder="Forge Expert" />
      </label>

      <label class="admin-field">
        <span>Prix numerique</span>
        <input type="number" min="0" formControlName="monthlyPriceEuros" />
      </label>

      <label class="admin-field">
        <span>Prix affiche</span>
        <input type="text" formControlName="displayPriceLabel" placeholder="149€ / user / month" />
      </label>

      <label class="admin-field">
        <span>Cle price Stripe</span>
        <input type="text" formControlName="stripePriceId" placeholder="price_xxx" />
      </label>

      <label class="admin-field">
        <span>Description</span>
        <input type="text" formControlName="description" placeholder="Description du plan" />
      </label>

      <label class="admin-field">
        <span>Badge</span>
        <input type="text" formControlName="badge" placeholder="Recommended" />
      </label>

      <label class="admin-field">
        <span>Ordre</span>
        <input type="number" min="0" formControlName="sortOrder" />
      </label>

      <div class="admin-toggle-grid">
        <label class="admin-checkbox">
          <input type="checkbox" formControlName="active" />
          <span>Plan actif</span>
        </label>

        <label class="admin-checkbox">
          <input type="checkbox" formControlName="highlight" />
          <span>Mettre en avant sur la landing</span>
        </label>
      </div>

      <div class="admin-feature-checklist">
        <article class="admin-feature-card" *ngFor="let feature of featureCatalog(); trackBy: trackFeature">
          <label class="admin-checkbox">
            <input type="checkbox" [formControl]="featureControl(feature.key)" />
            <span>{{ feature.label }}</span>
          </label>
          <div class="admin-table-secondary">{{ feature.description }}</div>
        </article>
      </div>

      <div class="admin-form-actions">
        <button class="primary-button" type="submit" [disabled]="saving()">
          {{ saving() ? 'Sauvegarde...' : selectedPlanKey() ? 'Mettre a jour' : 'Ajouter' }}
        </button>
        <button class="secondary-button" type="button" (click)="startCreate()">Reinitialiser</button>
      </div>
    </form>
  </aside>
</section>
